import React from "react";
import { Link } from "react-router-dom";

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <header className="bg-[#feb053] text-white shadow px-4 py-2 flex justify-center sm:justify-start items-center">
        <Link to="/" className="flex items-center">
          <img
            src="/logo.png"
            alt="TripsFlare Logo"
            className="h-12 sm:h-16 object-contain max-w-full"
            style={{ maxWidth: "100%" }}
          />
        </Link>
      </header>
      <main className="p-4 sm:p-6 max-w-7xl mx-auto w-full">{children}</main>
    </div>
  );
};

export default PublicLayout;
